module.exports = __webpack_public_path__ + "img/5terGeburtstag.f030aae0.svg";